import PropTypes from 'prop-types';
var TabType = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelMobile: PropTypes.string,
  totalCount: PropTypes.number,
  className: PropTypes.string,
  renderZeroCount: PropTypes.bool
};
export default TabType;